import { NGXLogger } from 'ngx-logger';
import { Injectable, inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { ProductService } from '../../product/services/product.service';
import { Observable, of, from, switchMap } from 'rxjs';
import { EncryptionService } from 'src/app/services/encryption.service';


@Injectable({
  providedIn: 'root',
})
export class ProductDetailResolver implements Resolve<any> {
  private readonly logger = inject(NGXLogger);

  constructor(
    private productService: ProductService,
    private router: Router,
    private encryptionService: EncryptionService
  ) { }

  // resolve(route: ActivatedRouteSnapshot): Observable<any> {
  //   const encryptedId = route.paramMap.get('id');
  //   if (encryptedId) {
  //     const decodedId = atob(encryptedId); // Decrypt the ID
  //     return this.productService.getProductById(decodedId).pipe(
  //       tap((response) => {
  //         console.log(`ProductDetailResolver response is ${JSON.stringify(response)}`)
  //       }),
  //       catchError((error) => {
  //         console.error(`ProductDetailResolver error is ${JSON.stringify(error)}`);
  //         this.router.navigate(['/error']); // Redirect on error
  //         return of(null);
  //       })
  //     );
  //   } else {
  //     this.router.navigate(['/products']);
  //     return of(null);
  //   }
  // }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const routeId = route.paramMap.get('id');
    if (routeId) {
      this.logger.debug(`[OPAQUE-ID][Product Resolver] resolving routeId=${routeId}`);
      return this.productService.getProductById(routeId).pipe(
        tap((response) => {
          this.logger.debug(`[OPAQUE-ID][Product Resolver] token response ${JSON.stringify(response)}`);
        }),
        catchError((tokenError) => {
          this.logger.warn(`[OPAQUE-ID][Product Resolver] token lookup failed, trying legacy encrypted id. error=${JSON.stringify(tokenError)}`);
          return from(this.encryptionService.decrypt(routeId)).pipe(
            switchMap((decodedId: any) =>
              this.productService.getProductById(decodedId).pipe(
                tap((response) => {
                  this.logger.debug(`[OPAQUE-ID][Product Resolver] legacy response ${JSON.stringify(response)}`);
                }),
                catchError((error) => {
                  this.logger.error(`[OPAQUE-ID][Product Resolver] legacy lookup error ${JSON.stringify(error)}`);
                  this.router.navigate(['/error']);
                  return of(null);
                })
              )
            ),
            catchError((error: any) => {
              this.logger.error(`[OPAQUE-ID][Product Resolver] legacy decrypt error ${error}`);
              this.router.navigate(['/products']);
              return of(null);
            })
          );
        })
      );
    } else {
      this.router.navigate(['/products']);
      return of(null);
    }
  }
}
